import React, { useContext, useEffect, useState } from 'react'
import './index.scss'
import { StoresContext } from '@App/contexts'
import { useNavigate } from 'react-router'
import Navigation from '@App/navigation'
import PointPreloader from '@Components/Preloaders/PointPreloader'
import Button from '@Components/Buttons/Button'
import { ICONS } from '@Const/common'
import PaginationComponent from '@Components/Tables/Pagination'
import { PaginationBody } from '@Entities/pagination'
import NoSongwritersMessage from '@Scenes/ProfileScene/ProfileSceneSongwriterTab/NoSongwritersMessage'
import SongwriterAccountCards from '@Components/Cards/AccountCard/SongwriterAccountCards'
import { observer } from 'mobx-react'

const ProfileSceneSongwriterTab = () => {
    const limitItems = 6
    const navigate = useNavigate()
    const { songwriterSearchStore } = useContext(StoresContext)
    const allSongwriters = songwriterSearchStore.songwriters
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        songwriterSearchStore.loadSongwriters({ page: 1, limit: limitItems }).finally(() => {
            setLoading(false)
        })
    }, [])

    const handlePagination = (pagination: PaginationBody) => {
        songwriterSearchStore.loadSongwriters(pagination).finally()
    }

    return loading ? (
        <PointPreloader />
    ) : allSongwriters.totalElements === 0 ? (
        <NoSongwritersMessage />
    ) : (
        <div className="profile-scene-songwriter-tab">
            <div className="songwriter-profile-top-section">
                <p>{allSongwriters.totalElements} Songwriter Accounts</p>
                <Button
                    mainColor
                    type="primary"
                    icon={ICONS.add}
                    onClick={() => navigate(Navigation.registrationSongwriter.root())}
                >
                    Add a Songwriter
                </Button>
            </div>
            <SongwriterAccountCards allSongwriters={allSongwriters} />
            {allSongwriters && allSongwriters.totalElements > limitItems && (
                <PaginationComponent
                    limit={limitItems}
                    paginationPages={songwriterSearchStore.paginationInfo}
                    onChange={handlePagination}
                />
            )}
        </div>
    )
}

export default observer(ProfileSceneSongwriterTab)
